module.exports = __webpack_public_path__ + "static/media/header-foreground-paths.12716eac.svg";